import type { FesLinkProps } from './FesLink';
import type { Maybe } from 'graphql/jsutils/Maybe';
import type { Ref } from 'react';

import { forwardRef } from 'react';

import { FesLink } from './FesLink';
import { LinkTarget } from '~/utilities/graphql/codegen';

type HybrisCmsLinkProps = Omit<FesLinkProps, 'target'> & { target?: Maybe<LinkTarget> };

const HybrisCmsLinkComponent = (
  { target, ...rest }: HybrisCmsLinkProps,
  ref: Ref<HTMLAnchorElement>
) => {
  const newWindow = target === LinkTarget.Newwindow;

  return (
    <FesLink
      {...rest}
      ref={ref}
      target={newWindow ? '_blank' : undefined}
      rel={newWindow ? 'noopener noreferrer' : undefined}
    />
  );
};

export const HybrisCmsLink = forwardRef(HybrisCmsLinkComponent);
